import { CalendarIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import { Box } from '@chakra-ui/react';
import Link from 'next/link';
import { PcSideButton } from './PcSideButton';
import { getPageInfo } from '@/config/pages';
import { ShopObject } from '@/graphql/generated/graphql';

export type PcSideButtonsProps = {
  shop: Pick<ShopObject, 'slug' | 'name' | 'recruitUrl' | 'isBookable'>;
};

export const PcSideButtons = ({
  shop,
}: PcSideButtonsProps) => {
  const {
    recruitUrl,
    isBookable
  } = shop;
  return (
    <>
      {isBookable &&
        <Link
          href={getPageInfo('studio/{slug}/booking', shop).href}
        >
          <PcSideButton
            bg={'brand.500'}
            top={'180px'}
            icon={
              <CalendarIcon
                mr={3}
                mb={2}
              />
            }
          >
            WEB予約する
          </PcSideButton>
        </Link>
      }
      {recruitUrl &&
        <Box
          as={'a'}
          href={recruitUrl}
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          <PcSideButton
            bg={'orange'}
            top={'430px'}
            icon={
              <ExternalLinkIcon
                mr={2}
                mb={2}
              />
            }
          >
            採用情報
          </PcSideButton>
        </Box>
      }
    </>
  );
};
